import { Spinner } from '@wartek-id/spinner'

import { useApiUserDetailProfile } from 'api/competency-mapping/useAPIUserDetail'

type EligibilityGuardProps = {
  children?: JSX.Element
}

function EligibilityGuard({ children }: EligibilityGuardProps) {
  // Hit the user detail API for eligibility check. The error will be handled by nearest ErrorBoundary
  const { isLoading, isError } = useApiUserDetailProfile('REFLEKSI', {
    /**
     * The eligibility check is considered to be used in every page.
     * Since the response is determined by the user identity,
     * it less likely to be changed during a session.
     * That means we can safely cache the result for a period of time (i.e. 30 min).
     * Unless the page is hard reloaded, it will not trigger refetch.
     **/
    staleTime: 30 * 60 * 1000, // stale after 30 min, force to refetch upon mounting
  })

  if (isLoading || isError) {
    // If error, we will also return the spinner as a fallback
    return (
      <div className="w-full h-screen flex justify-center items-center">
        <Spinner size="lg" />
      </div>
    )
  }

  return children
}

export default EligibilityGuard
